import { put } from 'redux-saga/effects';

import { actions as uiActions } from '../../ui';

export function* hideFiltersMenu() {
    yield put(uiActions.hideFiltersMenu());
}

export function* accordionClose(payload) {
    const { groupName: group, name } = payload;
    yield put(uiActions.accordionClose({ group, name }));
}

export const changeBeforeApplyFiltersStrategy = {
    hideFiltersMenu,
    accordionClose,
};
